import { createContext } from 'react'
import { Theme } from './Theme'
import * as themes from './themes'
export const ThemeContext = createContext<Theme>(themes.default)
export default ThemeContext
